import polar from './themes/polar';

export default function getTheme(name) {
    let theme;
    switch(name) {
        case 'polar':
            theme = polar
            break;
        default:
            theme = polar
            break;
    }
    return theme;
}